// Client-side helper: build URLs that respect Astro's `base` setting.
//
// Astro prefixes EVERY route — pages and API endpoints alike — with `base`
// (`/resources-list` here). A naive `fetch("/api/diag")` from the browser would hit
// the host root, outside the mount, and 404. `import.meta.env.BASE_URL` is
// inlined at build time, so this needs no runtime config.
export function apiUrl(path: string): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

/** Server-side: the same mount prefix, e.g. for cookie `Path=` scoping. */
export function basePath(): string {
  return import.meta.env.BASE_URL.replace(/\/$/, "") || "/";
}
